import { Component, Input, OnChanges } from '@angular/core';
import { TemporaryPermanentEnum } from '@app/features/allocate/models/driver-type.enum';
import {
  CONFIRM_PAGE_TITLE,
  ERROR_PAGE_TITLE,
  LOADING_PAGE_TITLE,
} from '@app/infrastructure/constants';
import { DateTimeHelpers } from '@global/infrastructure/helpers/date-time-helpers';

import { PanelState } from '@global/infrastructure/interfaces/panel-state';

@Component({
  selector: 'app-feature-wrapper',
  templateUrl: './feature-wrapper.component.html',
  styleUrls: ['./feature-wrapper.component.scss'],
})
export class FeatureWrapperComponent implements OnChanges {
  @Input() panelConfig: PanelState;
  @Input() policyId: string;
  @Input() isProgressing = false;
  @Input() policyChangeDate: Date;
  @Input() journeyPath: any;
  @Input() vehicle: any;
  @Input() selectedPolicyChange: string;

  featureIndex = 0;
  currentFeatures: string[] = [];
  totalPages: number;
  titleIcon: string;
  policyChangeDateString: string;
  showProgressBar: boolean;
  showPolicyIdentifier: boolean;
  isPermanent = false;
  visibleExpection = false;
  titleException = 'How to pay';

  onActivate(event) {
    window.scroll(0, 0);
  }

  ngOnChanges(): void {
    this.currentFeatures = this.journeyPath.path;
    this.totalPages = this.currentFeatures.length - 1;
    this.featureIndex = this.currentFeatures.indexOf(
      this.panelConfig.breadcrumbFeatureName
    );
    this.policyChangeDateString = DateTimeHelpers.toWordFormat(
      this.policyChangeDate
    );
    if (!this.currentFeatures.includes('prefferedPaymentDate') && !this.currentFeatures.includes('directDebitEdit')
      && this.panelConfig.breadcrumbFeatureName === 'directDebitDisplay') {
      this.visibleExpection = true;
    } else {
      this.visibleExpection = false;
    }
    this.titleIcon = this.panelConfig.icon;
    this.showProgressBar = this.panelConfig?.mainTitle?.length >= 0;
    this.showPolicyIdentifier =
      [LOADING_PAGE_TITLE, ERROR_PAGE_TITLE, CONFIRM_PAGE_TITLE].indexOf(
        this.panelConfig?.pageTitle
      ) === -1 &&
      (this.vehicle?.reg?.length > 0 || this.vehicle?.vehicleRegistration);
    this.isPermanent =
      this.selectedPolicyChange === TemporaryPermanentEnum.permanent;
  }
}
